import { Container, Tabs, useBreakpointValue } from "@chakra-ui/react"
import TitleBar from "../UI/TitleBar"
import AuthorsTable from "../../routes/_layout/authors"
import AuthorGroupsTable from "../../routes/_layout/authorgroups"
import { useNavigate, useRouterState } from "@tanstack/react-router"
import PermissionsTable from "../../routes/_layout/permissions"
import RolesTable from "../../routes/_layout/roles"
import UsersTable from "../../routes/_layout/users"
import MimeTypeTable from "../../routes/_layout/settings/mimetypes"
import SettingsGeneralContent from "../../routes/_layout/settings/index"
import ContactTable from "../../routes/_layout/forms/index"
import { useMemo } from "react"
import NewsletterTable from "../../routes/_layout/forms/newsletters"
import SubscriptionTable from "../../routes/_layout/forms/subscriptions"
import SubscriptionsTable from "../../routes/_layout/settings/subscriptions"
import PriocategoriesTable from "../../routes/_layout/settings/priocategories"
import RatechartsTable from "../../routes/_layout/settings/ratecharts"
import NavigationTable from "../../routes/_layout/settings/navigation"
import LandingpageTable from "../../routes/_layout/settings/landingpage"
import ActionsControlPanel from "../../routes/_layout/settings/actions";

interface TabsProps {
    tabs: {value: string, title: string}[]
    defaultVal: string
}

type TabKey =
    | "authors"
    | "authorgroups"
    | "users"
    | "roles"
    | "permissions"
    | "settings"
    | "settings/navigation"
    | "settings/landingpage"
    | "settings/mimetypes"
    | "settings/subscriptions"
    | "settings/priocategories"
    | "settings/ratecharts"
    | "settings/actions"
    | "forms"
    | "forms/newsletters"
    | "forms/subscriptions"


function TabsList({tabs, defaultVal}: TabsProps) {
    const navigate = useNavigate()
    const location = useRouterState({ select: s => s.location.pathname })

    const currentValue = tabs.find(tab => `/${tab.value}` === location)?.value || defaultVal

    const isMobile = useBreakpointValue({ base: true, md: false })

    const tabContent: Record<TabKey, JSX.Element> = useMemo( () => ({
        authors: <AuthorsTable />,
        authorgroups: <AuthorGroupsTable />,
        users: <UsersTable />,
        roles: <RolesTable />,
        permissions: <PermissionsTable />,
        settings: <SettingsGeneralContent />,
        "settings/navigation": <NavigationTable />,
        "settings/landingpage": <LandingpageTable />,
        "settings/mimetypes": <MimeTypeTable />,
        "settings/subscriptions": <SubscriptionsTable />,
        "settings/priocategories": <PriocategoriesTable />,
        "settings/ratecharts": <RatechartsTable />,
        "settings/actions": <ActionsControlPanel />,
        forms: <ContactTable />,
        "forms/newsletters": <NewsletterTable />,
        "forms/subscriptions": <SubscriptionTable />,
    }), [] )

    return (
        <Container maxW="full">

            <TitleBar title={tabs.find(tab => tab.value === currentValue)?.title || ""} />

            <Tabs.Root
                mt={4}
                value={currentValue}
                onValueChange={({ value }) => {
                    navigate({ to: `/${value}` })
                }}
                lazyMount
                unmountOnExit
                variant="outline"
                defaultValue={defaultVal}
                orientation={isMobile ? "vertical" : "horizontal"}
            >
                <Tabs.List>
                    {tabs.map((tab) => (
                        <Tabs.Trigger key={`${tab.value}`} value={`${tab.value}`}>
                            {tab.title}
                        </Tabs.Trigger>
                    ))}
                </Tabs.List>

                {tabs.map((tab) => (
                    <Tabs.Content key={`${tab.value}`} value={`${tab.value}`}>
                        {tabContent[tab.value as TabKey]}
                    </Tabs.Content>
                ))}
            </Tabs.Root>
        </Container>
    )
}

export default TabsList
